var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"margin-top":"15px"}},[_c('car-search-panel',{attrs:{"show-errors":true},on:{"callback":_vm.redirection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }